<template>
    <div class="to-login-temp" :style="{'--theme-color': themeColor}">
        <div class="to-login-temp-imh">
            <img src="https://bigdata.topeti.com/PCRepository/image/login-tips.png">
        </div>
        <div class="to-login-temp-btn" @click="goLogin">
            <div>登录</div>
        </div>
    </div>
</template>

<script>
export default {
    // 组件名称
    name: 'toLoginTemp',
    // 组件参数 接收来自父组件的数据
    props: {
        themeColor: {
            type: String,
            default: '#4e86ff'
        }
    },
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {}
    },
    // 计算属性
    computed: {},
    // 侦听器
    watch: {},
    // 组件方法
    methods: {
        goLogin() {
          this.$emit('open-login')  
        },
    },
}
</script>

<style scoped lang="scss">
$themeColor: var(--theme-color);
.to-login-temp {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &-btn {
        padding: 8px 32px;
        background-color: $themeColor;
        color: #fff;
        margin-top: 20px;
        border-radius: 4px;
        cursor: pointer;
    }
}
</style>
